import { CachedItem } from "@lib-shared/lib";
import { logApiError } from "core/lib";
import { FreshDeskService } from "core/services/fresh-desk.service";
import { Ticket } from "core/types/ticket";
import TicketStore from "./ticket.store";

class TicketStoreManager {
    _cache = new CachedItem("queries", true, 120);
    _api = new FreshDeskService();
    _store;
    _auth;

    constructor(auth: any, store: TicketStore) {
        this._auth = auth;
        this._store = store;
    }

    get store() {
        return this._store;
    }

    private _processTicketResponseData(inputData: Ticket[]) {
        inputData.forEach((a: Ticket) => {
            //Using requester_id for when a user's name was set after a ticket was created
            //which was mainly during testing. But it also means if a user's name changes
            //all the tickets will get updated.
            a.submittedBy = this._auth.id === a.requester_id
                ? this._auth.name
                : a.custom_fields.cf_created_by;
            // a.created_at = new Date(a.created_at);
        });

        return inputData;
    }

    async loadTicketsAsync(clearCache = false) {
        console.log("Fetching tickets");

        this._store.updateIsLoading(true);

        let data: Ticket[] = [];

        try {
            if (!clearCache && this._cache.isCached) {
                console.log("Using cached queries");
                data = this._cache.value;
            } else {
                const response = await this._api.getTicketsAsync();

                data = response?.data == null
                    ? []
                    : this._processTicketResponseData(response.data);

                this._cache.set(data);
            }

            this._store.updateItems(data);
            this._store.updateErrorLoading(false);
        } catch (error) {
            logApiError(error);

            this._store.updateErrorLoading(true);
            this._store.updateItems([]);
        }

        this._store.updateIsLoading(false);
    }
}

export default TicketStoreManager;
